<template>
  <div>
    <div class="tx-c m-b-10">财务数据统计</div>
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        prop="project_name"
        label="项目"
        width="300">
      </el-table-column>
      <el-table-column label="统计对象">
        <el-table-column
          prop="month"
          label="本月累计开票收入"
          width="300">
        </el-table-column>
        <el-table-column
          prop="year"
          label="本年累计开票收入"
          width="300">
        </el-table-column>
        <el-table-column
          prop="month_before"
          label="截止本月末止累计开票收入"
          min-width="400">
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  export default {
    iden: 'finance',
    data() {
      return {
        tableData: [],
        loading: false
      }
    },
    created() {
      this.getData()
    },
    methods: {
      async getData() {
        this.loading = true
        let res = await this.apiGet('statistic/project/get_finance_count')
        let data = this.promiseHandler(data, res)
        this.tableData = data
        this.loading = false
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// finance.vue?c2bc3392